export default __webpack_public_path__ + "static/media/app-banner.89def69d.svg";